<template>
  <div class="circle-badge" :class="[badgeStyle || 'default-badge']">
    <span><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: "CircleBadge",
  props: ['badgeStyle'],
}
</script>

<style scoped lang="scss">
  .circle-badge {
    display: inline-block;
    line-height: 26px;
    padding: 0 13px 1px;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 800;

    &.default-badge {
      background-color: $sub-color;
      color: #fff;
    }

    &.yellow-badge {
      background-color: $main-color;
      color: #000;
    }

    & + .circle-badge {
      margin-left: 6px;
    }
  }
</style>
